/**
 * Created by D K Rai on 5/9/2018.
 */

import React, {Component} from 'react';
import Pagination from "react-js-pagination";
import {Link} from 'react-router-dom';
import InvalidAccessOrLogin from '../errorsPage/InvalidAccessOrLogin';
import * as AppConstant from '../common/AppConstant'

class StaffList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            staffList: [],
            loggedInUser:{},
            status: '',
            activeNumber: 1,
            count: 0,
            showLoader:false,
            redirectToErrorPage:false,
            redirectToForbiddenPage: false,
            apiStatus: {
                isError: false,
                message: '',
                messages: ''
            },
            jwtToken:this.props.jwtToken
        }
        this.fetchAllStaff = this.fetchAllStaff.bind(this);
        this.fetchLoggedInStaff = this.fetchLoggedInStaff.bind(this);
    }

    componentDidMount() {
        this.fetchLoggedInStaff();
        if(this.props.params && this.props.params.msg) {
            const {apiStatus} = this.state;
            apiStatus.isError = false;
            apiStatus.message = this.props.params.msg;
            this.setState({apiStatus: apiStatus});
        }
    }

    fetchLoggedInStaff(){
        let _this = this;
        fetch(this.props.api + '/staff/currentUser', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    _this.props.onLogoutClick(json.message);
                }else{
                    if(json && json.staff && json.staff.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER"))){
                        _this.setState({loggedInUser: json.staff}, function(){
                            _this.fetchAllStaff(null);
                        })
                    }else{
                        this.setState({redirectToErrorPage:true})
                    }
                }
                _this.setState({showLoader:false});
            }).catch(error => {
            console.log(error)
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.jwtToken !== this.state.jwtToken) {
            this.setState({jwtToken: nextProps.jwtToken},()=>{
                console.debug("JWT UPDATED")
                this.fetchAllStaff(null);
            });
        }
    }

    fetchAllStaff(event) {
        let activePageNumber = 0;
        if (event !== null && isNaN(event) === true)
            event.preventDefault();
        else if (event !== null && isNaN(event) === false) {
            activePageNumber = (parseInt(event + '', 10) - 1);
            this.setState({activeNumber: event});
        }
        //console.log("==event=" + event + "======" + isNaN(event) + "====activePageNumber=" + activePageNumber);
        let url = this.props.api + "/staff?offset=" + activePageNumber + "&limit=" + 50;
        this.setState({showLoader:true})
        fetch(url, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.state.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                console.log(json);
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.props.onLogoutClick(json.message);
                } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                    this.setState({showLoader: false, redirectToForbiddenPage: true});
                } else {
                    this.setState({staffList: json.content, count: json.totalElements});
                    this.setState({showLoader: false})
                }
            }).catch(error => {
            this.setState({showLoader:false})
            console.log(error);
        });
    }
    refreshPageData(event) {
        this.setState({staffList: []});
        this.setState({activeNumber: 1});
        this.setState({ count:0});
        this.setState({    apiStatus: {
                isError: false,
                message: ''
            }});
        this.setState({showLoader:false});
        this.componentDidMount()
    }
    render() {
        let _this = this;
        return (
            <div className="wrapper animated fadeInRight">
                <InvalidAccessOrLogin jwtToken={this.state.jwtToken}
                                      redirectToErrorPage={this.state.redirectToErrorPage}
                                      redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="dashboard-table-wrap">
                            <div className="heading-wrapper clearfix">
                                <p className="m-t-xs">{_this.props.msg('staff.label.staffListHeader')}</p>
                                <div className="pull-right text-right " style={{position:'relative'}}>
                                    <Link className="btn btn-primary" to={'/staff/create'} style={{marginRight:'85px'}}>{_this.props.msg('form.label.createStaff')}</Link>

                                    <div className="m-b-md" style={{position:'absolute', right:'0', top:'3px'}}>
                                        <button type="button" className="btn btn-white btn-sm" style={{marginRight: '10px'}} onClick={ this.refreshPageData.bind(this) }>{_this.props.msg('form.label.refresh')}</button>
                                    </div>
                                </div>

                            </div>
                            {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                            <div className="table-box table-responsive p-m">
                                <div style={{'textAlign': 'center'}}>
                                                  <span
                                                      style={{'color': this.state.apiStatus.isError === true ? 'red' : 'green'}}> {this.state.apiStatus.message ? this.state.apiStatus.message : ''}</span>
                                    <br/>
                                </div>
                                <table className="table table-condensed-xs">
                                    <thead>
                                    <tr>
                                        <th>{_this.props.msg('table.th.name')}</th>
                                        <th>{_this.props.msg('table.th.email')}</th>
                                        <th>{_this.props.msg('table.th.username')}</th>
                                        <th className="header text-center">{_this.props.msg('table.th.loginEnabled')}</th>
                                        <th className="header"  style={{paddingLeft:"138px"}}>{_this.props.msg('table.th.roles')}</th>
                                        <th className="header text-left">{_this.props.msg('table.th.action')}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.staffList && this.state.staffList.map(function (staff, index) {
                                        return (
                                            <tr key={Math.random()}>
                                                <td>{staff.firstName} {staff.lastName}</td>
                                                <td>{staff.emailPrimary}</td>
                                                <td >{staff.username}</td>
                                                <td style={{textAlign: 'center'}}>
                                                    <i className={staff.loginEnabled===true?'fa fa-check':'fa fa-times'}></i>
                                                </td>
                                                <td style={{paddingLeft:"90px"}}>
                                                    { staff.userRoles && staff.userRoles.map(function (role) {
                                                            return <li key={Math.random()}>
                                                                {role}
                                                            </li>
                                                        }
                                                    )}
                                                </td>
                                                <td className="text-left">
                                                    <Link to={'/staff/update/'+staff.id} className="btn btn-white btn-sm"><i
                                                        className="fa fa-edit"></i>
                                                        <span className="hidden-xs hidden-sm"> Edit</span>
                                                    </Link>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                        <td colSpan="6" className="footable-visible">
                                <Pagination
                                    activePage={this.state.activeNumber}
                                    itemsCountPerPage={50}
                                    totalItemsCount={this.state.count}
                                    pageRangeDisplayed={5}
                                    onChange={this.fetchAllStaff}
                                />
                                        </td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
                <style dangerouslySetInnerHTML = {{__html: `
                p { margin:0 0 2px;}
                .table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
                  padding: 4px;
                }
                `}} />
            </div>
        )
    }
}
export default StaffList;


// WEBPACK FOOTER //
// ./src/components/security/StaffList.js